import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import ButtonSound from 'app/ui/buttons/ButtonSound';

const UNGROUPED = 'UNGROUPED';
const CENTER = 'CENTER';
const TOP_LEFT = 'TOP_LEFT';
const TOP_RIGHT = 'TOP_RIGHT';
const TOP_RIGHT_2 = 'TOP_RIGHT_2';
const BOTTOM_LEFT = 'BOTTOM_LEFT';
const BOTTOM_RIGHT = 'BOTTOM_RIGHT';
const BOTTOM_CENTER = 'BOTTOM_CENTER';

class HudButtons extends Phaser.Group {
  constructor(game) {
    super(game);
    this.state = null;
    this.buttons = {};
  }

  init(buttonsConfig) {
    this.buttonsConfig = buttonsConfig;
    this.createButtonGroups();
  }

  positionElements() {
    const paddingX = this.game.screenPaddingX;
    const paddingY = this.game.screenPaddingY;
    this.positionButtonGroups(paddingX, paddingY);
  }
  /*
  ====================================================================================
    BUTTONS
  ====================================================================================
  */
  positionButtonGroups(paddingX, paddingY) {
    const w = this.game.width;
    const h = this.game.height;
    this.buttonGroups.forEach((group) => {
      this.positionButtonGroupButtons(group, paddingY);
      const RIGHT = w - paddingX - group.groupWidth;
      const BOTTOM = h - group.groupHeight - paddingY;
      const CENTER_X = w / 2 - group.groupWidth / 2;
      const CENTER_Y = h / 2 - group.groupHeight / 2;
      switch (group.screenPosition) {
        case TOP_LEFT:
          group.x = paddingX;
          group.y = paddingY;
          break;
        case TOP_RIGHT:
          group.x = RIGHT;
          group.y = paddingY;
          break;
        case BOTTOM_LEFT:
          group.x = paddingX;
          group.y = BOTTOM;
          break;
        case BOTTOM_RIGHT:
          group.x = RIGHT;
          group.y = BOTTOM;
          break;
        case BOTTOM_CENTER:
          group.x = CENTER_X;
          group.y = BOTTOM;
          break;
        case CENTER:
          group.x = CENTER_X;
          group.y = CENTER_Y;
          break;
      }
    });
  }

  positionButtonGroupButtons(btnGroup, padding) {
    btnGroup.groupWidth = 0;
    btnGroup.groupHeight = 0;
    btnGroup.buttons.forEach((btn, index) => {
      if (btnGroup.screenPosition === UNGROUPED) {
        btn.updatePosition();
      } else {
        btn.x = index === 0 ? btn.x : btnGroup.groupWidth + padding;
        btnGroup.groupWidth = btn.x + btn.width;
        btnGroup.groupHeight = Math.max(btnGroup.groupHeight, btn.height);
        if (btn.padding_left) {
          let pad = this.game.defaultWidth * btn.padding_left;
          btn.x += pad;
          btnGroup.groupWidth += pad;
        }
        if (btn.padding_bottom) {
          let pad = this.game.defaultHeight * btn.padding_bottom;
          btn.y -= pad;
          btnGroup.groupHeight += pad;
        }
      }
    });
  }

  createButtonGroups() {
    this.btnsTopLeft = this.createButtonGroup(TOP_LEFT);
    this.btnsTopRight = this.createButtonGroup(TOP_RIGHT);
    this.btnsBottomLeft = this.createButtonGroup(BOTTOM_LEFT);
    this.btnsBottomRight = this.createButtonGroup(BOTTOM_RIGHT);
    this.btnsBottomCenter = this.createButtonGroup(BOTTOM_CENTER);
    this.btnsCenter = this.createButtonGroup(CENTER);
    this.btnsUngrouped = this.createButtonGroup(UNGROUPED);
    this.buttonGroups = [
      this.btnsTopLeft,
      this.btnsTopRight,
      this.btnsBottomLeft,
      this.btnsBottomRight,
      this.btnsBottomCenter,
      this.btnsCenter,
      this.btnsUngrouped,
    ];
    this.buttonGroupLookup = {
      TOP_LEFT: this.btnsTopLeft,
      TOP_RIGHT: this.btnsTopRight,
      TOP_RIGHT_2: this.btnsTopRight,
      BOTTOM_LEFT: this.btnsBottomLeft,
      BOTTOM_RIGHT: this.btnsBottomRight,
      BOTTOM_CENTER: this.btnsBottomCenter,
      CENTER: this.btnsCenter,
      UNGROUPED: this.btnsUngrouped,
    };
  }

  createButtonGroup(position) {
    let group = this.game.make.group();
    group.groupWidth = 0;
    group.groupHeight = 0;
    group.buttons = [];
    group.screenPosition = position;
    this.add(group);
    return group;
  }

  addToButtonGroup(position, btn) {
    const btnGroup = this.buttonGroupLookup[position];
    btnGroup.add(btn);
    btn.buttonGroup = btnGroup;
    btnGroup.buttons.push(btn);
  }

  destroyButtons() {
    Object.keys(this.buttons).map((id, i) => {
      let button = this.buttons[id];
      button.buttonGroup.buttons.splice(button.buttonGroup.buttons.indexOf(button), 1);
      button.onInputDown.remove(this.handleButtonInteraction, this);
      button.destroy(true);
      button = null;
      return button;
    });
    this.buttons = {};
  }

  createButtons(screenConfig) {
    this.buttons = {};
    screenConfig.forEach((option) => {
      this.createButton(option);
    });
  }

  createButton(option) {
    const data = this.buttonsConfig[option];
    if (data) {
      const { id, sfx_id, skin, position, ariaLabelID, skins } = data;
      console.log('creating button : ' + id);
      const opts = { game: this.game, id, position, sfx_id, skin, ariaLabelID };
      let btn;
      if (id === 'btn_sound') {
        opts.skins = skins;
        btn = new ButtonSound(opts);
      } else {
        btn = new ButtonSimple(opts);
      }
      this.buttons[id] = btn;
      btn.onInputDown.add(this.handleButtonInteraction, this);
      if (position.grouped) {
        this.addToButtonGroup(position.id, btn);
      } else {
        this.addToButtonGroup(UNGROUPED, btn);
      }
      return btn;
    }
  }

  renderButtons(opts, handleButtonInteraction) {
    this.handleButtonInteraction = handleButtonInteraction;
    this.destroyButtons();
    this.createButtons(opts);
  }

  /*
  ====================================================================================
    CLEANUP
  ====================================================================================
  */
  destroy(destroyChildren = true, soft) {
    /*
     *  TODO : cleanup
     */
    super.destroy(true);
  }
}

export default HudButtons;
